import type React from "react";

interface CombinedTextFieldAndUnitProps
	extends React.InputHTMLAttributes<HTMLInputElement> {
	name: string;
	label: string;
	inputType?: "text" | "number";
	unit: string;
	bgStyle?: "transparent" | "filled";
	required?: boolean;
	invalid?: boolean;
}

export const CombinedTextFieldAndUnit = ({
	name,
	label,
	inputType = "text",
	unit,
	bgStyle = "transparent",
	required = false,
	invalid = false,
	...extraInputProps
}: CombinedTextFieldAndUnitProps) => {
	return (
		<div className="flex flex-col gap-2">
			<label htmlFor={name}>
				{label}
				{required ? (
					""
				) : (
					<span className="ml-1 text-secondary-500">(optional)</span>
				)}
			</label>
			<div className={`flex ${invalid ? "ring-red-200 rounded ring-4" : ""}`}>
				<input
					className={`border border-r-0 p-2 w-full ${bgStyle === "transparent" ? "bg-transparent" : "bg-white"} rounded-l text-gray-900 ${
						invalid ? "border-primary" : "border-secondary-200"
					}`}
					name={name}
					type={inputType}
					aria-label={name}
					{...extraInputProps}
				/>
				<div
					className={`py-2 px-3 whitespace-nowrap ${bgStyle === "transparent" ? "bg-transparent" : "bg-white"} rounded-r font-normal border ${
						invalid
							? "border-primary border-l-secondary-200"
							: "border-secondary-200"
					}`}
				>
					{unit}
				</div>
			</div>
		</div>
	);
};
